import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette } from '../../theme';

const useStyles = makeStyles(() =>
  createStyles({
    imgWrapper: {
      background: colorsPalette.violetAnalyticsCard,
    },
  }),
);

export default useStyles;
